import { render } from "./DeleteFromReturnBoxConfirmModal.vue?vue&type=template&id=ed5029e6"
import script from "./DeleteFromReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteFromReturnBoxConfirmModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/DeleteFromReturnBoxConfirmModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed5029e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed5029e6', __exports__)) {
    console.log('reload')
    api.reload('ed5029e6', __exports__)
  }
  
  module.hot.accept("./DeleteFromReturnBoxConfirmModal.vue?vue&type=template&id=ed5029e6", () => {
    console.log('re-render')
    api.rerender('ed5029e6', render)
  })

}


export default __exports__